import React from 'react'
import MuiTable from '../../../Forms/SharedComponents/containers/MuiTable'
import { TABLA_DETALLE_DESCARGA_POR_GRADO } from '../../../../config/tables'

function DetalleDescargaPorGradoView () {
  return (
    <MuiTable id={TABLA_DETALLE_DESCARGA_POR_GRADO} />
  )
}

export default DetalleDescargaPorGradoView
